<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chidebres0007#ch01"><span class="sm-b">ONE</span>   What Is Memoir?</a></p>
<p class="toc"><a class="xref" href="#/chidebres0008#ch02"><span class="sm-b">TWO</span>   Is All Memoir Really Fiction?</a></p>
<p class="toc"><a class="xref" href="#/chidebres0009#ch03"><span class="sm-b">THREE</span>   Should Memoirists Aim to Tell the Truth?</a></p>
<p class="toc"><a class="xref" href="#/chidebres0010#ch04"><span class="sm-b">FOUR</span>   What Do Memoirists Owe the People They Write About?</a></p>
<p class="toc"><a class="xref" href="#/chidebres0011#ch05"><span class="sm-b">FIVE</span>   Why Write a Memoir?</a></p>
<p class="tocbmf"><a class="xref" href="#/chidebres0012#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chidebres0013#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chidebres0014#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chidebres0015#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-debres-0006.vue?d80ecb42